import { Box, TextField, Button, Typography, useTheme } from "@mui/material";
import { BaseStepProps } from "../types/types";
import { tokens } from "../../../theme";

interface StepProps extends BaseStepProps {
  onNext: () => void;
  onPrevious: () => void;
}

export default function Step3Finance({
  formData,
  onChange,
  onPrevious,
  onNext,
  onSaveGear,
}: StepProps) {
  
  const theme = useTheme()
  const colors = tokens(theme.palette.mode)

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Length
          </Typography>
          <TextField
            fullWidth
            placeholder="cm"
            size="small"
            value={formData.length}
            onChange={(e) => onChange("length", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Height
          </Typography>
          <TextField
            fullWidth
            placeholder="cm"
            size="small"
            value={formData.height}
            onChange={(e) => onChange("height", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Width
          </Typography>
          <TextField
            fullWidth
            placeholder="cm"
            size="small"
            value={formData.width}
            onChange={(e) => onChange("width", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Weight
          </Typography>
          <TextField
            fullWidth
            placeholder="kgs"
            size="small"
            value={formData.weight}
            onChange={(e) => onChange("weight", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Transport Volume
          </Typography>
          <TextField
            fullWidth
            placeholder="cm"
            size="small"
            value={formData.transportVolume}
            onChange={(e) => onChange("transportVolume", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Measuring Unit
          </Typography>
          <TextField
            fullWidth
            placeholder="cm"
            size="small"
            value={formData.measuringUnit}
            onChange={(e) => onChange("measuringUnit", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
          gap: 2,
        }}
      >
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Current
          </Typography>
          <TextField
            fullWidth
            placeholder="A"
            size="small"
            value={formData.current}
            onChange={(e) => onChange("current", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
        <Box>
          <Typography
            variant="body2"
            sx={{
              fontWeight: 600,
              color: colors.primary[400],
              mb: 0.5,
              fontSize: "0.88rem",
            }}
          >
            Power
          </Typography>
          <TextField
            fullWidth
            placeholder="W"
            size="small"
            value={formData.power}
            onChange={(e) => onChange("power", e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: colors.primary[800],
                borderRadius: "16px",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "none" },
                "&.Mui-focused fieldset": { border: "none" },
              },
            }}
          />
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 2,
        }}
      >
        <Box sx={{ display: "flex", gap: 3 }}>
          <Typography
            onClick={onPrevious}
            sx={{
              cursor: "pointer",
              fontWeight: 600,
              textDecoration: "underline",
              color: colors.primary[400],
              fontSize: "0.9rem",
            }}
          >
            Previous
          </Typography>
          <Typography
            onClick={onSaveGear}
            sx={{
              cursor: "pointer",
              fontWeight: 600,
              textDecoration: "underline",
              color: colors.primary[400],
              fontSize: "0.9rem",
            }}
          >
            Save Gear
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="large"
          onClick={onNext}
          sx={{
            backgroundColor: colors.primary[400],
            px: 5,
            py: 1.2,
            borderRadius: "24px",
            "&:hover": { backgroundColor: colors.primary[500]},
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
  );
}
